import { Link } from 'react-router-dom';
import { SITE_URL } from '@/utils/site';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: `${SITE_URL}/` },
      ...items.map((it, i) => {
        const entry: Record<string, string> = {
          '@type': 'ListItem',
          position: String(i + 2),
          name: it.label,
        };
        if (it.to) entry.item = `${SITE_URL}${it.to}`;
        return entry;
      }),
    ],
  };

  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-sm text-foreground-600">
      <ol className="flex flex-wrap items-center gap-1.5">
        <li>
          <Link to="/" className="transition-colors hover:text-primary-600">
            首页
          </Link>
        </li>
        {items.map((it, idx) => (
          <li key={idx} className="flex flex-wrap items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
            {it.to ? (
              <Link to={it.to} className="transition-colors hover:text-primary-600">
                {it.label}
              </Link>
            ) : (
              <span aria-current="page" className="font-medium text-foreground-950">
                {it.label}
              </span>
            )}
          </li>
        ))}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </nav>
  );
}